// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--HbQay";